import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { WithUserData } from '@grandvisionhq/my-account';
import { withUserToken } from '../../../../hoc/with-user-token.js';
import CancelAppointmentContainer from './CancelAppointmentContainer.js';

const CancelAppointmentRootWithUserToken = withUserToken(CancelAppointmentContainer);
const CancelAppointmentRootWithUserData = WithUserData(CancelAppointmentRootWithUserToken);
const CancelAppointmentRootWithMyAccountEnabled = (_param)=> {
    var props = swcHelpers.extends({}, _param);
    return React.createElement(CancelAppointmentRootWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: true
    }));
};

export { CancelAppointmentRootWithMyAccountEnabled as default };
//# sourceMappingURL=CancelAppointmentRootWithUserToken.js.map
